export const qkAppSettingsFromDB = "app-settings-from-db";
export const qkAppSettingsPermissionList = "app-settings-permissions-list";
export const appSettingsQueryKey = "app-settings";
export const qkappSettingsSchema = "app-settings-schema";
